/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Coordinates,
    CoordinatesFromJSON,
    CoordinatesFromJSONTyped,
    CoordinatesToJSON,
    StationType,
    StationTypeFromJSON,
    StationTypeFromJSONTyped,
    StationTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface Station
 */
export interface Station {
    /**
     * 
     * @type {string}
     * @memberof Station
     */
    stationId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Station
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Station
     */
    iataCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Station
     */
    iataName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Station
     */
    displayName?: string | null;
    /**
     * 
     * @type {StationType}
     * @memberof Station
     */
    stationType?: StationType;
    /**
     * 
     * @type {string}
     * @memberof Station
     */
    countryCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Station
     */
    countryName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Station
     */
    countryEffective?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof Station
     */
    locationCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Station
     */
    locationName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Station
     */
    locationEffective?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof Station
     */
    timeZone?: string | null;
    /**
     * 
     * @type {Coordinates}
     * @memberof Station
     */
    coordinates?: Coordinates;
    /**
     * 
     * @type {number}
     * @memberof Station
     */
    readonly latitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Station
     */
    readonly longitude?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Station
     */
    enabled?: boolean | null;
    /**
     * 
     * @type {object}
     * @memberof Station
     */
    effectiveDateFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof Station
     */
    effectiveDateTo?: object | null;
    /**
     * 
     * @type {string}
     * @memberof Station
     */
    updatedBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Station
     */
    updatedDate?: Date;
}

export function StationFromJSON(json: any): Station {
    return StationFromJSONTyped(json, false);
}

export function StationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Station {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stationId': !exists(json, 'stationId') ? undefined : json['stationId'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'iataCode': !exists(json, 'iataCode') ? undefined : json['iataCode'],
        'iataName': !exists(json, 'iataName') ? undefined : json['iataName'],
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
        'stationType': !exists(json, 'stationType') ? undefined : StationTypeFromJSON(json['stationType']),
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'countryName': !exists(json, 'countryName') ? undefined : json['countryName'],
        'countryEffective': !exists(json, 'countryEffective') ? undefined : json['countryEffective'],
        'locationCode': !exists(json, 'locationCode') ? undefined : json['locationCode'],
        'locationName': !exists(json, 'locationName') ? undefined : json['locationName'],
        'locationEffective': !exists(json, 'locationEffective') ? undefined : json['locationEffective'],
        'timeZone': !exists(json, 'timeZone') ? undefined : json['timeZone'],
        'coordinates': !exists(json, 'coordinates') ? undefined : CoordinatesFromJSON(json['coordinates']),
        'latitude': !exists(json, 'latitude') ? undefined : json['latitude'],
        'longitude': !exists(json, 'longitude') ? undefined : json['longitude'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'effectiveDateFrom': !exists(json, 'effectiveDateFrom') ? undefined : json['effectiveDateFrom'],
        'effectiveDateTo': !exists(json, 'effectiveDateTo') ? undefined : json['effectiveDateTo'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
        'updatedDate': !exists(json, 'updatedDate') ? undefined : (new Date(json['updatedDate'])),
    };
}

export function StationToJSON(value?: Station | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stationId': value.stationId,
        'allowEdit': value.allowEdit,
        'iataCode': value.iataCode,
        'iataName': value.iataName,
        'displayName': value.displayName,
        'stationType': StationTypeToJSON(value.stationType),
        'countryCode': value.countryCode,
        'countryName': value.countryName,
        'countryEffective': value.countryEffective,
        'locationCode': value.locationCode,
        'locationName': value.locationName,
        'locationEffective': value.locationEffective,
        'timeZone': value.timeZone,
        'coordinates': CoordinatesToJSON(value.coordinates),
        'enabled': value.enabled,
        'effectiveDateFrom': value.effectiveDateFrom,
        'effectiveDateTo': value.effectiveDateTo,
        'updatedBy': value.updatedBy,
        'updatedDate': value.updatedDate === undefined ? undefined : (value.updatedDate.toISOString()),
    };
}


